import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1.6rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 0.5px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  justify-content: space-between;
  height: auto;
  right: 0;
  top: 7rem;
  z-index: ${({ theme }) => theme.zIndex.low};

  ${({ theme }) => theme.media.laptop`
  display: flex;
  `}
`;

export const VerticalItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.6rem;
`;

export const OperationItemsWrapper = styled.div`
  display: flex;
  gap: 1.6rem;
  align-items: center;
`;
